export default __webpack_public_path__ + "static/media/web-control.f29018e0.svg";